import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class ScraperService {
  public hostUrl: any = environment.API_BASE_URL;

  public urlToGetScraperStats: any = this.hostUrl + 'api/getPdfScraperStats';
  public urlToGetAllPdfScrapers: string =
    environment.SCRAPER_BASE_URL + 'pdfScraper/getAllScrapers';
  public usrToGetOneScraper: string = environment.SCRAPER_BASE_URL + 'pdfScraper/getOneScraper';

  constructor(private _http: HttpClient) {}

  public getPdfScraperStats(data = {}): Observable<any> {
    return this._http.post(this.urlToGetScraperStats, data).map((res: Response) => res);
  }
  public fetchAllPdfScrapers(): Observable<any> {
    return this._http.get(this.urlToGetAllPdfScrapers).map((res: Response) => res);
  }
  public fetchScraperById(id): Observable<any> {
    return this._http.get(this.usrToGetOneScraper + '/' + id).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/scraper.service.ts